import styled from 'styled-components';

export const InputStyles = styled.div`
  width: 100%;
  position: relative;

  .label-text {
    color: ${props => props.theme.gray600};
    position: absolute;
    top: 50%;
    left: 0.5rem;
    transform: translateY(-50%);
    pointer-events: none;
    transition: all 0.1s ease-in-out;
    max-width: calc(100% - 1rem);
    overflow: hidden;
    white-space: nowrap;
    z-index: 1;
  }

  label {
    width: 100%;
    height: auto;
    position: relative;
    margin-bottom: 0.5rem;

    &.is-raised,
    &:focus-within {
      .label-text {
        font-size: 0.8rem;
        top: 0.75rem;
        color: ${props => props.theme.gray600};

        + .field-control {
          padding: 1rem 0.5rem 0;
        }
      }
    }

    #industry * {
      outline: none !important;
      box-shadow: none !important;
    }
  }

  .field-control {
    display: block;
    width: 100%;
    height: 3rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: ${props => props.theme.gray700};
    background-color: white;
    background-clip: padding-box;
    border: 1px solid #bdc5c4;
    border-radius: 0.25rem;
    padding: 1rem 0.5rem;
    outline: none;
    appearance: none;

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(139, 149, 165, 0.25);
      border-color: ${props => props.theme.gray400};
    }

    &.has-error {
      border-color: #dc3545;
      background-repeat: no-repeat;
      background-position: right calc(0.375em + 0.1875rem) center;
      background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
  }

  select {
    &.field-control {
      background-image: url('/static/images/icons/dropdown-arrow.svg');
      background-position: right 10px center;
      background-size: 10px 10px;
      background-repeat: no-repeat;
    }
  }

  .error-message {
    font-size: 0.8rem;
    color: #dc3545;
    margin-top: -0.5rem;
    margin-bottom: 0.5rem;
  }

  &.credit-card-field {
    &:after {
      content: '';
      height: 2rem;
      width: 3.25rem;
      background-repeat: no-repeat;
      background-size: contain;
      display: block;
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      filter: opacity(0.6);

      ${props => (props.error ? 'background: transparent !important;' : '')};
    }

    &.visa {
      &:after {
        background-image: url('/icons/credit-cards/visa.png');
      }
    }

    &.mastercard {
      &:after {
        background-image: url('/icons/credit-cards/mastercard.png');
      }
    }

    &.discover {
      &:after {
        background-image: url('/icons/credit-cards/discover.png');
      }
    }

    &.american-express {
      &:after {
        background-image: url('/icons/credit-cards/amex.png');
      }
    }

    input {
      letter-spacing: 1px;
    }
  }
`;
